<template>
  <div class="dialog-container overlay" @click="close" v-show="showCharacterDialog || isDialogSending">

    <div id="character-dialog" class="dialog" @click.stop v-show="showCharacterDialog">
      <div>
        <input placeholder="Adj nevet a karakternek" type="text" maxlength="30" v-model="charaDialogName">
      </div>
      <div>
        <input placeholder="Adj meg egy adatlap linket" type="text" maxlength="255" v-model="charaDialogUrl">
      </div>
      <div>
        <div id="color-picker">
          <spectrum-colorpicker v-model="charaDialogColor" :value='charaDialogColor'
                                :color='charaDialogColor'></spectrum-colorpicker>
        </div>
        <button v-if="charaDialogAvatar" class="icon-button remove-avatar-button"
                style="height: 10px;" @click="removeAvatar">
          <i class="material-icons" title="Avatár eltávolítása">no_photography</i>
        </button>
        <button class="icon-button add-avatar-button" style="height: 10px;" @click="openImageSelect">
          <i v-if="charaDialogAvatar" class="material-icons" title="Avatár cseréje">linked_camera</i>
          <i v-else class="material-icons" title="Avatár hozzáadása">add_a_photo</i>
        </button>
      </div>
      <div>
        <span>Inaktív</span>
        <input type="checkbox" v-model="charaDialogHidden">
      </div>
      <div>
        <button type="button" class="outline-button" @click="submit">Mentés</button>
        <button type="button" class="outline-button" @click="close">Mégse</button>
      </div>
    </div>

    <template v-if="isDialogSending">
      <i class="material-icons">hourglass_full</i>
      <span>Betöltés...</span>
    </template>
    <image-dialog ref="charImageDialog" :avatar-select="true" :send="addImage"></image-dialog>
  </div>
</template>

<script>
import jQuery from 'jquery';
import 'spectrum-colorpicker2/dist/spectrum.css';
import 'spectrum-colorpicker2';
import ImageDialog from './image-dialog.vue';
import {isValidUrl} from "../utils/utils";

export default {
  props: [
    'send'
  ],
  data() {
    return {
      showCharacterDialog: false,
      charaDialogHidden: false,
      charaDialogId: null,
      charaDialogName: '',
      charaDialogUrl: '',
      charaDialogAvatar: '',
      charaDialogColor: '#dddddd',
      isDialogSending: false
    };
  },
  computed: {
    isValid() {
      if (this.charaDialogUrl && !isValidUrl(this.charaDialogUrl)) {
        alert("Helytelen url!");
        return false;
      }
      if (this.charaDialogAvatar && !isValidUrl(this.charaDialogAvatar)) {
        alert("Helytelen url!");
        return false;
      }
      if (this.charaDialogName.trim().length === 0) {
        alert("Helytelen név!");
        return false;
      }
      return true;
    }
  },
  methods: {
    removeAvatar() {
      this.charaDialogAvatar = '';
    },
    openImageSelect() {
      if (this.charaDialogAvatar) {
        this.$refs.charImageDialog.open({_id: this.charaDialogId, url: this.charaDialogAvatar});
      } else {
        this.$refs.charImageDialog.open();
      }
    },
    addImage(data) {
      return new Promise((resolve) => {
        this.charaDialogAvatar = data.url;
        resolve();
      });
    },
    open(chara) {
      if (chara != null) {
        this.charaDialogId = chara._id;
        this.charaDialogName = chara.name;
        this.charaDialogUrl = chara.url;
        this.charaDialogAvatar = chara.avatar;
        this.charaDialogHidden = chara.hidden;
        this.charaDialogColor = chara.color;
      } else {
        this.charaDialogId = null;
        this.charaDialogName = '';
        this.charaDialogUrl = '';
        this.charaDialogAvatar = '';
        this.charaDialogHidden = false;
        // leave charaDialogColor as it was
      }
      this.showCharacterDialog = true;
    },
    close() {
      if (!this.isDialogSending) {
        this.showCharacterDialog = false;
      }
    },
    submit() {
      if (!this.isValid) {
        return;
      }

      const data = {
        name: this.charaDialogName,
        url: this.charaDialogUrl,
        avatar: this.charaDialogAvatar,
        color: this.charaDialogColor,
        hidden: this.charaDialogHidden
      };

      this.showCharacterDialog = false;
      this.isDialogSending = true;

      this.send(data, this.charaDialogId)
          .then(res => {
            if (this.charaDialogId) {
              this.$emit('edited', res);
            } else {
              this.$emit('created', res);
            }
            this.isDialogSending = false;
          })
          .catch(() => {
            this.isDialogSending = false;
          });
    }
  },
  components: {
    ImageDialog,
    'spectrum-colorpicker': {
      props: ['value', 'color'],
      render: h => h('input', {ref: 'colorpicker'}),
      mounted() {
        const emitInput = (color) => this.$emit('input', color.toHexString());
        jQuery(this.$refs['colorpicker']).spectrum({
          type: "color",
          color: this.value,
          showInput: true,
          preferredFormat: "hex",
          showAlpha: false,
          allowEmpty: false,
          locale: "hu",
          change: emitInput,
        });
      },
      watch: {
        value(value) {
          jQuery(this.$refs['colorpicker']).spectrum('set', value);
        }
      }
    }
  }
};
</script>
